<template>
  <div>
    <v-dialog v-model="open" width="500">
      <v-card>
        <v-card-title>
          <span class="red--text font-weight-bold"
            >ยืนยันยกเลิกรายวิชา {{ subject_id }} กลุ่มเรียน {{ section }}</span
          >
        </v-card-title>
        <v-card-text class="red pt-4 white--text">
          <div class="white--text">
            ปิดรายวิชา = ยังแสดงในหน้าตารางสอนและแสดงข้อความ "รายวิชาปิด"
            แต่นักศึกษาจะไม่สามารถลงทะเบียนในรายวิชานี้ได้
          </div>
          <div class="white--text pt-2">
            ลบรายวิชา = ลบรายวิชาออกจากหน้าตารางสอน
          </div>
          <div v-if="cannotDeleteRegistered" class="yellow--text font-weight-bold pt-4">
            รายวิชานี้ไม่สามารถลบได้ เนื่องจากยังมีนักศึกษาลงทะเบียนเรียนรายวิชานี้อยู่
          </div>
          <div class="yellow--text pt-6">
            <v-icon color="yellow">mdi-alert</v-icon>ข้อควรระวัง
          </div>
          <div class="white--text">
            เมื่อดำเนินการปิด/ลบรายวิชาแล้ว จะไม่สามารถย้อนรายวิชานี้กลับมาได้
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="red" @click="closeTeachTable()" :disabled="closing" :loading="closing">
            <v-icon>mdi-table-off</v-icon>
            ปิดรายวิชา
          </v-btn>
          <v-btn outlined color="red" @click="deleteTeachTable()" :disabled="canceled == '1' || cannotDeleteRegistered">
            <v-icon>mdi-trash-can</v-icon>
            ลบรายวิชา
          </v-btn>
          <v-btn outlined color="dark" @click="open = false">ปิดหน้าต่าง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tableTableProvider from "@/services/teach_table.provider.js";
const tableTableService = new tableTableProvider();

export default {
  name: "CloseTeachTableDialog",
  props: {
    levelId: {
      type: [String, Number],
      default: 1,
    },
  },
  data: () => ({
    open: false,
    teach_table_id: null,
    subject_id: null,
    section: null,
    closed: null,
    closing: false,
    canceled: null,
    registered_count: 0,
  }),
  computed: {
    cannotDeleteRegistered() {
      return this.registered_count > 0;
    },
  },
  methods: {
    open_dialog(teach_table_id, subject_id, section, closed, registeredCount = 0) {
      this.open = true;
      this.teach_table_id = teach_table_id;
      this.subject_id = subject_id;
      this.section = section;
      this.closed = closed;
      this.canceled = null;
      this.registered_count = this.normalizeRegisteredCount(registeredCount);
    },
    normalizeRegisteredCount(value) {
      if (typeof value === "number") return value;
      if (String(value).trim() === "เต็ม/Full") return 1;
      const count = parseInt(value, 10);
      return Number.isNaN(count) ? 0 : count;
    },
    async closeTeachTable() {
      if (this.closing) return;
      this.closing = true;
      await tableTableService
        .closeTeachTable({
          teach_table_id: this.teach_table_id,
          level_id: this.levelId,
        })
        .then(() => {
          this.closed = '1';
          this.$router.go(0);
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        })
        .finally(() => {
          this.closing = false;
        });
    },
    async deleteTeachTable() {
      if (this.cannotDeleteRegistered) return;
      this.canceled = '1';
      await tableTableService
        .deleteTeachTable({
          teach_table_id: this.teach_table_id,
          level_id: this.levelId,
        })
        .then(() => {
          this.$router.go(0);
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });
    },
  },
};
</script>

<style>
</style>
